'use client';

import { useTranslations } from 'next-intl';
import { ErrorScreen } from '@/lib/components/ErrorScreen';
import { Button } from '@/lib/ui-kit/button';
import { LottieIllustration } from '@/lib/ui-kit/lottie-illustration';

export default function AppSegmentError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errors.global');

  return (
    <ErrorScreen
      icon={<LottieIllustration name="500-error" size={380} height={150} offsetY={-40} />}
      title={t('title')}
      description={t('description')}
      action={
        <Button
          variant="contained"
          onClick={() => reset()}
          className="h-[38px] w-[200px] rounded-[10px] bg-white px-4 py-3 text-[13px] font-medium leading-4 tracking-[-0.13px] text-[#0E1011] hover:bg-[#0B71FF] hover:text-white"
        >
          {t('solution')}
        </Button>
      }
    />
  );
}
